export type AccountIdsCsv =
  | { readonly kind: 'ids'; readonly ids: readonly number[] }
  | { readonly kind: 'error'; readonly error: string };

const ID_HEADERS = new Set(['id', 'account id', 'accountid']);

const isAccountId = (value: string) => /^\d+$/.test(value);

const cellsOf = (line: string) =>
  line.split(',').map((cell) =>
    cell
      .trim()
      .replace(/^"(.*)"$/, '$1')
      .trim(),
  );

const idColumn = (header: readonly string[]) =>
  Math.max(
    header.findIndex((cell) => ID_HEADERS.has(cell.toLowerCase())),
    0,
  );

const hasHeader = (header: readonly string[]) => !isAccountId(header[0] ?? '');

export const parseAccountIdsCsv = (text: string): AccountIdsCsv => {
  const rows = text
    .split(/\r?\n/)
    .filter((line) => line.trim() !== '')
    .map(cellsOf);
  const header = rows[0] ?? [];
  const column = hasHeader(header) ? idColumn(header) : 0;
  const values = (hasHeader(header) ? rows.slice(1) : rows).map((row) => row[column] ?? '');
  const invalid = values.filter((value) => !isAccountId(value));

  if (invalid.length > 0)
    return { kind: 'error', error: `Not an account ID: ${invalid.slice(0, 3).join(', ')}` };
  if (values.length === 0) return { kind: 'error', error: 'The CSV has no account IDs.' };
  return { kind: 'ids', ids: [...new Set(values.map(Number))] };
};
